<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <footer class="ChapterFooter">
            <div class="ChapterFooter-container">
                <div class="ChapterFooter-socialNav">
                    <social-nav :items="followItems" light>
                        Síguenos
                    </social-nav>
                </div>
                <router-link :to="auctionRoute" class="ChapterFooter-bttn">
                    <small>Subasta Moleskine</small>
                </router-link>
            </div>
            <div class="ChapterFooter-container">
                <p class="ChapterFooter-disclaimer">
                    {{data.legal.disclaimer}}
                </p>
            </div>
        </footer>
    </transition>
</template>

<script>
    import * as routes from '@/app/routes'
    import SocialNav from './SocialNav'

    export default {
        name: 'ChapterFooter',
        components: {
            SocialNav,
        },
        data() {
            return {
                followItems: [
                    {
                        id: 'facebook',
                        iconId: 'icon-facebook',
                        url: 'https://www.facebook.com/Moleskine',
                        target: '_blank',
                    },
                    {
                        id: 'twitter',
                        iconId: 'icon-twitter',
                        url: 'https://twitter.com/moleskine',
                        target: '_blank',
                    },
                ],
            }
        },
        methods: {
            intro(el, done) {
                TweenLite.fromTo(el, 0.5, {
                    alpha: 0,
                }, {
                    alpha: 1,
                    onComplete: done,
                    ease: Sine.easeOut,
                })
            },
            outro(el, done) {
                TweenLite.to(el, 0.5, {
                    alpha: 0,
                    onComplete: done,
                    ease: Sine.easeOut,
                })
            },
        },
        computed: {
            data() {
                const {$store} = this
                return $store.getters.data
            },
            auctionRoute() {
                return {
                    name: routes.AUCTION,
                }
            },
        },
    }
</script>

<style src="styles/components/ChapterFooter.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/ChapterFooter.vue